export { default } from './Card';



// WEBPACK FOOTER //
// ./src/components/Card/index.ts